import { useAtomValue } from "jotai";
import { useMemo } from "react";

import { useUserTypes } from "~/lib/hooks";
import { rosettaAtom } from "~/lib/rosetta";

export const useMostLikelyToSubscribe = () => {
  const { userTypes } = useUserTypes();
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const pianoIsLikelyToSubscribe =
    asyncRosettaState?.result?.instance?.rulesEngine.getFact("isLikelyToSubscribe") ?? false;

  const isMostLikelyToSubscribeUser = useMemo(
    () => userTypes.map(element => element.id).includes("018") || pianoIsLikelyToSubscribe,
    [pianoIsLikelyToSubscribe, userTypes],
  );

  return {
    isMostLikelyToSubscribeUser,
  };
};
